import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import "./Search.css";
import search from "modules/search";

class Search extends Component {
  constructor(props) {
    super(props);
    this.getFilter = this.getFilter.bind(this);
  }

  getFilter(item) {
    this.refs.input.value = item.text;
    delete item.caption;
    this.props.getFilter(item);

    if (item.type === "address" && item.id) {
      this.props.history.push(`/libraries/${item.id}`);
    }
  }

  render() {
    return (
      <div>
        <div className="margin-normal">
          <div className="input-title">Поиск</div>
        </div>
        <div className="search">
          <div className="input-container">
            <input
              type="text"
              onChange={e => {
                e.target.value
                  ? this.props.getType(e.target.value)
                  : this.props.getFilter(e.target.value);
              }}
              onBlur={e => this.props.clearFilter()}
              placeholder="Библиотека, станция метро, район"
              ref="input"
            />
            <svg
              className="search-icon"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.2857 12.5714H13.3714L13.0286 12.2286C14.1714 10.9714 14.8571 9.25714 14.8571 7.42857C14.8571 3.31429 11.5429 0 7.42857 0C3.31429 0 0 3.31429 0 7.42857C0 11.5429 3.31429 14.8571 7.42857 14.8571C9.25714 14.8571 10.9714 14.1714 12.2286 13.0286L12.5714 13.3714V14.2857L18.2857 20L20 18.2857L14.2857 12.5714ZM7.4283 12.5713C4.57116 12.5713 2.28545 10.2856 2.28545 7.42848C2.28545 4.57134 4.57116 2.28562 7.4283 2.28562C10.2854 2.28562 12.5712 4.57134 12.5712 7.42848C12.5712 10.2856 10.2854 12.5713 7.4283 12.5713Z"
                fill="#2B2B2B"
              />
            </svg>
            <button className="input-button">Найти</button>
          </div>
          {this.props.type.length ? (
            <ul className="list">
              {this.props.type.map((item, index) => {
                return (
                  <li
                    key={index}
                    onMouseDown={() => this.getFilter({ ...item })}
                  >
                    <div>{item.caption}</div>
                    <div>{item.text.replace(/\*/, "/")}</div>
                  </li>
                );
              })}
            </ul>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  type: state.search.type
});

const mapDispatchToProps = dispatch => ({
  getType: bindActionCreators(search.actions.getType, dispatch),
  getFilter: bindActionCreators(search.actions.getFilter, dispatch),
  clearFilter: bindActionCreators(search.actions.clearFilter, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Search)
);



// WEBPACK FOOTER //
// ./src/components/Search/Search.js